import React, { Component } from 'react';
import noBridgeDeepGradient from '../../img/no-bridge-deep-gradient.png'
import onlyBridge from '../../img/only-bridge-centered.png'
import bridgeTowers from '../../img/bridge-towers.png'
import './WhatIf.css'

//components
// import Filter from './Filter'
import Content from './Content'
import Options from './Options'

// data
import data from './OptionsData'

var counter = 0
var carouselDisabled = false

class WhatIf extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: data,
      carousel: {
        index: 0,
        direction: null
      },
      percentage: 0
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleCarousel = this.handleCarousel.bind(this)
    this.loadPercentage = this.loadPercentage.bind(this)
    this.increment = this.increment.bind(this)
  }

  componentDidMount() {
    document.title = "What If - Out of Last Place Mississippi"
  }

  loadPercentage() {
    let previousPercentage = this.state.percentage
    let newPercentage = this.state.data[this.state.carousel.index].content.percentage
    let difference = Math.abs(newPercentage - previousPercentage)
    let greater = previousPercentage < newPercentage
    this.interval = setInterval(this.increment, (1800/difference), difference, greater)
  }

  increment(difference, greater) {
    if (difference > counter && greater) {
      counter++
      this.setState({
        percentage: this.state.percentage + 1
      } )
    } else if (difference > counter && !greater) {
      counter++
      this.setState({
        percentage: this.state.percentage - 1
      })
    } else {
      window.clearInterval(this.interval)
      counter = 0
      carouselDisabled = false
    }
  }

  handleChange(value) {
    this.setState({
      value: value,
      carousel: {
        index: (value ? this.state.data.indexOf(value) : 0)
      }
    }, this.loadPercentage )
  }

  handleCarousel(selectedIndex, e) {
    if (carouselDisabled) {
      e.preventDefault()
    } else {
      carouselDisabled = true
      this.setState({
        value: this.state.data[selectedIndex].value,
        carousel: {
          index: selectedIndex,
          direction: e.direction
        }
      }, this.loadPercentage )
    }
  }


  render() {

    var bridgeStyle = {
      width: ( ( ( this.state.data[this.state.carousel.index].content.percentage / 100 ) * 57.78) + "%")
    }

    return (
      <section className="what-if-section" >

        <div className="container-fluid heading-container" >
          <h1 className="what-if-heading">What If...</h1>
          <Options carousel={this.state.carousel} data={this.state.data} handleChange={this.handleChange} value={this.state.value}/>
        </div>

        <div className="bridge-background-whatif" >
          <div className="only-bridge-whatif" style={bridgeStyle} >
            <img src={onlyBridge} alt="bridge" className="bridge-img"/>
          </div>

          <img src={bridgeTowers} className="bridge-towers" alt="bridge" />
          <img src={noBridgeDeepGradient} className="no-bridge-whatif" alt="no bridge" />
          <h3 className="percentage">{this.state.percentage + "%"}</h3>
          <Content
            handleCarousel={this.handleCarousel}
            carousel={this.state.carousel}
            data={this.state.data}
            />
        </div>

      </section>
    );
  }
}

export default WhatIf;



/** WEBPACK FOOTER **
 ** ./src/components/pages/WhatIf.js
 **/